__turbopack_context__.v({
  "link": "TravelModeLink-module-scss-module__m44HvG__link",
});
